import { type Dispatch, type SetStateAction, useEffect, useState } from 'react';

import { IMMERSIVE_NAV_SCROLL_THRESHOLD } from '@/components/GlobalNavigation/DesktopNav/DesktopNav';

const useNavTransparency = (
  immersive: boolean | undefined,
  scrollPosition: number,
  scrollDirection: string
): [boolean, Dispatch<SetStateAction<boolean>>] => {
  const [transparentNav, setTransparentNav] = useState<boolean>(false);

  // Immersive transparency: Once a user scrolls away, nav is no longer transparent
  // biome-ignore lint/correctness/useExhaustiveDependencies: Automated migration to Biome
  useEffect(() => {
    if (
      scrollDirection === 'down' &&
      immersive &&
      scrollPosition >= IMMERSIVE_NAV_SCROLL_THRESHOLD
    ) {
      setTransparentNav(false);
    }
  }, [scrollDirection, scrollPosition]);

  //sent initial transparency
  useEffect(() => {
    setTransparentNav(immersive || false);
  }, [immersive]);

  return [transparentNav, setTransparentNav];
};

export default useNavTransparency;
